export class SeededRandom {
  constructor(seed = 0, state) {
    this.seed = seed >>> 0;
    this.state = state === undefined ? this.seed : state >>> 0;
  }

  next() {
    this.state = (this.state + 0x6d2b79f5) >>> 0;
    let value = this.state;
    value = Math.imul(value ^ (value >>> 15), value | 1);
    value ^= value + Math.imul(value ^ (value >>> 7), value | 61);
    return ((value ^ (value >>> 14)) >>> 0) / 4294967296;
  }

  pick(items) {
    return items[
      Math.min(items.length - 1, Math.floor(this.next() * items.length))
    ];
  }

  snapshot() {
    return { seed: this.seed, state: this.state };
  }
}

export function deriveSeed(seed, stream) {
  let value = (seed >>> 0) ^ 0x811c9dc5;
  for (const character of stream) {
    value ^= character.charCodeAt(0);
    value = Math.imul(value, 0x01000193) >>> 0;
  }
  return value >>> 0;
}
